import ServiceBase from './ServiceBase';

export default class HomepageSectionsService extends ServiceBase {
    getHomepageSections() {
        return this.request('get', 'homepageSections/getHomepageSections');
    }

    saveHomepageSections(sections) {
        return this.request('post', 'homepageSections/saveHomepageSections', { sections });
    }
}
